import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import api from "../lib/api";
import { Layout } from "../components/Layout";
import { FactCard } from "../components/FactCard";
import { useVisitor } from "../context/VisitorAuthContext";

const Favourites = () => {
  const { visitor, favourites, openAuth } = useVisitor();
  const [items, setItems] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "My Favourites · CurioVault";
    return () => { document.title = "CurioVault"; };
  }, []);

  useEffect(() => {
    if (visitor) {
      api.get("/visitor/favourites").then((r) => setItems(r.data)).catch(() => setItems([]));
    }
  }, [visitor, favourites]);

  if (visitor === null) {
    return (
      <Layout>
        <div className="max-w-6xl mx-auto px-6 py-24 text-center font-body text-[#7A6C5D]">Opening your reading room…</div>
      </Layout>
    );
  }

  if (!visitor) {
    return (
      <Layout>
        <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="favourites-signin-prompt">
          <div className="w-14 h-14 mx-auto rounded-full border-2 border-[#C5A059] flex items-center justify-center text-[#9E4535] mb-5">
            <Heart className="w-6 h-6" />
          </div>
          <h1 className="font-serif-display text-3xl sm:text-4xl font-bold text-[#1A1615]">Your favourite curios</h1>
          <p className="font-body text-base text-[#4A4036] mt-4 leading-relaxed">
            Sign in to keep a personal cabinet of the curios you love, and return to them whenever curiosity strikes.
          </p>
          <button
            onClick={openAuth}
            data-testid="favourites-signin-button"
            className="mt-7 font-ui text-sm font-semibold px-7 py-3 bg-[#9E4535] text-[#FAF7F0] rounded-full hover:bg-[#82382B] transition-colors"
          >
            Sign in to begin
          </button>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <div className="border-b border-[#D8CEB9] pb-6 mb-8">
          <p className="caption-label mb-1">Your Private Cabinet</p>
          <h1 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1A1615]">My Favourites</h1>
        </div>

        {items === null ? (
          <p className="font-body text-[#7A6C5D]">Retrieving your collection…</p>
        ) : items.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="favourites-grid">
            {items.map((f, i) => <FactCard key={f.slug} fact={f} index={i} />)}
          </div>
        ) : (
          <div className="text-center py-16" data-testid="favourites-empty">
            <p className="font-body text-[#4A4036] text-lg">You have not saved any curios yet.</p>
            <Link to="/" className="inline-block mt-5 font-ui text-sm font-semibold px-6 py-3 border border-[#9E4535] text-[#9E4535] rounded-full hover:bg-[#9E4535] hover:text-[#FAF7F0] transition-colors">
              Explore the vault
            </Link>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Favourites;
